export enum NotificationCenterUtilities {
	METADATA_PLATE = 'plate',
	METADATA_CHASSIS = 'chassis',
	METADATA_CATEGORY = 'category',
	METADATA_CONTEXT = 'context',
	METADATA_DETAIL = 'detail',
	METADATA_TAGS = 'tags',
	CLOSING_CATEGORY_EQUIPMENT = 'equipment',
	CLOSING_CATEGORY_MAINTENANCE = 'maintenance',
	CLOSING_CATEGORY_CLAIMS = 'claims',
	CLOSING_CATEGORY_NOTES = 'notes',
	CLOSING_CATEGORY_SURVEY = 'survey',
	REDIRECT_URL_UUID = 'REDIRECT_URL_UUID',
	REDIRECT_URL_PREFIX = 'REDIRECT_URL_PREFIX',
	REDIRECT = 'REDIRECT'
}


export const CLOSING_MAP_CATEGORIES: NotificationCenterUtilities[] = [
	NotificationCenterUtilities.CLOSING_CATEGORY_EQUIPMENT,
	NotificationCenterUtilities.CLOSING_CATEGORY_NOTES,
	NotificationCenterUtilities.CLOSING_CATEGORY_SURVEY
];
